import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from "@angular/core";
import {
  provideRouter,
  withInMemoryScrolling,
  Router,
  Scroll,
} from "@angular/router";
import { filter } from "rxjs";
import { routes } from "./app.routes";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { MSAL_PROVIDERS } from "./core/providers/msal.provider";
import { provideConfigInitializer } from "./core/providers/config.providers";
import { provideTransloco } from "./core/providers/transloco.provider";
import { Title } from "@angular/platform-browser";
import { ViewportScroller } from "@angular/common";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: "top",
        anchorScrolling: "disabled",
      })
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideTransloco(),
    provideConfigInitializer(),
    Title, // Provide the Title service
    provideAppInitializer(() => {
      const router = inject(Router);
      const viewportScroller = inject(ViewportScroller);

      const fragmentOffsets: Record<string, number> = {
        "develop-myself": 100,
        "better-know-myself": 100,
        "discover-our-jobs": 130,
        "mobility-project-exchange": 130,
        "mobility-offer-application": 100,
      };

      router.events
        .pipe(filter((e): e is Scroll => e instanceof Scroll))
        .subscribe((e) => {
          if (e.anchor) {
            viewportScroller.setOffset([0, fragmentOffsets[e.anchor] ?? 100]);
            setTimeout(() => viewportScroller.scrollToAnchor(e.anchor!), 0);
          } else if (e.position) {
            viewportScroller.scrollToPosition(e.position);
          } else {
            viewportScroller.scrollToPosition([0, 0]);
          }
        });
    }),
    ...MSAL_PROVIDERS,
  ],
};
